function formatFlashSaleTime(value) {
  return value.toString().padStart(2, '0');
}

function getStoredSaleEndTime(storageKey) {
  try {
    var stored = localStorage.getItem(storageKey);
    var parsed = parseInt(stored, 10);
    return Number.isNaN(parsed) ? null : parsed;
  } catch (e) {
    return null;
  }
}

function setStoredSaleEndTime(storageKey, endTime) {
  try {
    localStorage.setItem(storageKey, String(endTime));
  } catch (e) {
    // ignore storage errors
  }
}

function getFixedSaleEndTime(element) {
  var fixedEnd = element.getAttribute('data-sale-end');
  if (!fixedEnd) {
    return null;
  }

  var parsed = Date.parse(fixedEnd);
  return Number.isNaN(parsed) ? null : parsed;
}

function updateFlashSaleCountdowns() {
  document.querySelectorAll('[data-sale-countdown-key], [data-sale-countdown]').forEach((element) => {
    var key = element.getAttribute('data-sale-countdown-key');
    var durationDays = parseInt(element.getAttribute('data-sale-duration-days'), 10);
    if (Number.isNaN(durationDays) || durationDays <= 0) {
      durationDays = 7;
    }

    var endTime = getFixedSaleEndTime(element);
    if (!endTime) {
      if (key) {
        var storageKey = 'flashSaleCountdownEnd-' + key;
        endTime = getStoredSaleEndTime(storageKey);
        if (!endTime) {
          endTime = Date.now() + durationDays * 24 * 60 * 60 * 1000;
          setStoredSaleEndTime(storageKey, endTime);
        }
      } else {
        var timestamp = parseInt(element.getAttribute('data-sale-countdown'), 10);
        if (Number.isNaN(timestamp)) {
          return;
        }
        endTime = timestamp * 1000;
      }
    }

    var remaining = endTime - Date.now();
    if (remaining <= 0) {
      element.textContent = 'Oferta terminada';
      return;
    }

    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    element.textContent = `Termina en ${formatFlashSaleTime(days)}:${formatFlashSaleTime(hours)}:${formatFlashSaleTime(minutes)}:${formatFlashSaleTime(seconds)}`;
  });
}

function syncFlashSaleStripHeight() {
  var strip = document.querySelector('.flash-sale-strip--global');
  if (!strip) {
    document.documentElement.style.removeProperty('--flash-sale-strip-height');
    return;
  }
  document.documentElement.style.setProperty('--flash-sale-strip-height', strip.offsetHeight + 'px');
}

document.addEventListener('DOMContentLoaded', function () {
  updateFlashSaleCountdowns();
  syncFlashSaleStripHeight();
  setInterval(updateFlashSaleCountdowns, 1000);
  window.addEventListener('resize', syncFlashSaleStripHeight);
});
